var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamundaLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    isolation: "isolate",
    position: "absolute",
    bottom: 0,
    left: 0
  },
  viewBox: "118.85 45.49 71.35 217.89"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "CamundaLogo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M118.85 45.49h71.35v217.89h-71.35z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#CamundaLogo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M154.44 200.8c23.49 0 35.58-13.85 35.76-38.22v-20.15h-22.61v21.73c0 10.87-4.74 14.73-12.45 14.73-7.54 0-12.45-3.86-12.45-14.73V82c0-10.87 4.74-15.08 12.45-14.9 7.54 0 12.45 4.2 12.45 15.07v16.26h22.61V83.7c0-24.37-12.1-38.21-35.59-38.21S119 59.33 118.85 83.7v79.06c0 24.02 12.15 38.04 35.59 38.04"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC5D0D",
  d: "M118.85 223.06h71.35v40.32h-71.35z"
}))));
export default SvgCamundaLogo;